"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createUserApi = void 0;
const react_1 = require("@reduxjs/toolkit/query/react");
/**
 * User API factory — see createTicketApi.ts for the shared-package baseQuery-injection pattern.
 * Backs the mobile ticket-edit assignee picker (T100/FR-020) with a server-proxied Microsoft
 * Graph user search (`Services/Tickets/.../Endpoints/Users/SearchUsersEndpoint.cs`), instead of
 * the web client's direct-to-Graph `searchGraphUsers` (which needs a delegated `User.Read.All`
 * scope mobile's Azure AD app registration doesn't have).
 */
const createUserApi = (baseQuery) => (0, react_1.createApi)({
    reducerPath: 'userApi',
    baseQuery,
    endpoints: (builder) => ({
        searchUsers: builder.query({
            query: (query) => ({
                url: 'users/search',
                params: { query },
            }),
        }),
        getMyPreferences: builder.query({
            query: () => 'UserPreferences/mine',
        }),
    }),
});
exports.createUserApi = createUserApi;
